<template>
  <div class="thank-you-page">
    <div class="container">
      <div class="content">
        <div class="logo-container">
          <img
            src="@/assets/images/logos/logo.png"
            alt="Zaytoon Logo"
            class="logo"
          />
        </div>

        <div class="icon-container">
          <i class="la la-check-circle check-icon"></i>
        </div>

        <h1 class="title">شكراً لاشتراكك</h1>
        <h2 class="subtitle">Thank you for your subscription</h2>

        <p class="message">
          سيتم توجيهك إلى الصفحة الرئيسية خلال <strong>{{ countdown }}</strong> ثانية
          <br>
          <small>You will be redirected to the home page in <strong>{{ countdown }}</strong> seconds</small>
        </p>

        <router-link :to="{ name: 'Home' }" class="btn-home">
          أو اضغط هنا / or press here
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { corevasAxios } from '@/corevas'
import { AUTH_TOKEN_KEY, AUTH_USER_KEY } from '@/constants'

export default {
  name: 'ThankYou',

  setup() {
    const router = useRouter()
    const route = useRoute()
    const countdown = ref(5)
    let intervalId = null

    const redirectToHome = () => {
      router.push({ name: 'Home' })
    }

    // Provas (corevas) operator redirect lands here with
    // ?ref=MTN&s=…&p=<phone>&u=<token>&tt=<uuid> — validate the token and
    // persist the session so the user arrives at Home authenticated.
    const urlHasToken = async () => {
      if (!route.query.u) return

      try {
        const res = await corevasAxios.get('auth/me', {
          headers: {
            Authorization: 'Bearer ' + route.query.u,
            Accept: 'application/json'
          }
        })

        if (res.status === 200 && res.data && res.data.data) {
          localStorage.setItem(AUTH_TOKEN_KEY, route.query.u)

          const me = res.data.data
          // Top-level flags are only populated when ?service= is passed;
          // otherwise derive them from the services[] array.
          const svc = (me.services || []).find(s => s.slug === process.env.VUE_APP_COREVAS_SERVICE)
          const operator = (me.operator || '').startsWith('mtn') ? 'MTN'
            : (me.operator || '').startsWith('sudani') ? 'Sudani' : 'Zain'
          // Same shape the app stores from the GraphQL me (Player gates on
          // subscription_model.has_active_billing), so consumers keep working.
          localStorage.setItem(AUTH_USER_KEY, JSON.stringify({
            id: me.id,
            name: me.phone,
            phone: me.phone,
            is_subscribed: svc ? svc.status === 'active' : !!me.is_subscribed,
            unreadNotificationsCount: 0,
            subscription_model: {
              id: null,
              operator,
              active_billing_until: (svc && svc.expires_at) || me.active_billing_until || null,
              has_active_billing: svc ? !!svc.has_active_billing : !!me.has_active_billing
            }
          }))
        }
      } catch (e) {
        // Invalid/expired token — leave the session as-is.
      }
    }

    onMounted(() => {
      urlHasToken()

      intervalId = setInterval(() => {
        countdown.value--
        if (countdown.value <= 0) {
          clearInterval(intervalId)
          redirectToHome()
        }
      }, 1000)
    })

    onBeforeUnmount(() => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    })

    return {
      countdown,
      redirectToHome
    }
  }
}
</script>

<style scoped>
.thank-you-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.container {
  width: 100%;
  max-width: 600px;
}

.content {
  background: white;
  border-radius: 16px;
  padding: 48px 32px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.logo-container {
  margin-bottom: 32px;
}

.logo {
  max-width: 200px;
  height: auto;
}

.icon-container {
  margin-bottom: 24px;
}

.check-icon {
  font-size: 80px;
  color: #4ade80;
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.title {
  font-size: 32px;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 8px;
}

.subtitle {
  font-size: 24px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 24px;
}

.message {
  font-size: 18px;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 32px;
}

.message strong {
  color: #059669;
  font-size: 24px;
}

.message small {
  display: block;
  margin-top: 8px;
  font-size: 14px;
  color: #9ca3af;
}

.btn-home {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 16px 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  text-decoration: none;
  display: inline-block;
}

.btn-home:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.btn-home:active {
  transform: translateY(0);
}
</style>
